import { render } from "./UserFishing.vue?vue&type=template&id=978fde80&scoped=true&ts=true"
import script from "./UserFishing.vue?vue&type=script&lang=ts"
export * from "./UserFishing.vue?vue&type=script&lang=ts"

import "./UserFishing.vue?vue&type=style&index=0&id=978fde80&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\mobileApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-978fde80"]])

export default __exports__